import ImageWithLabel from './component'

export default ImageWithLabel